import angular from "angular";

angular
    .module('app')
    .component('individualCourseSettings', {
        template: require('./individual-course-settings.html'),
        controller: ['$http', 'Notifier', 'ErrorResponseParser', controller],
        bindings: {
            course: '<',
        }
    });

function controller($http, Notifier, ErrorResponseParser) {


    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.openSale = $ctrl.course.open_sale;
        $ctrl.cost = $ctrl.course.cost;
        $ctrl.discountValue = $ctrl.course.discount_value;
        $ctrl.onlinePayment = $ctrl.course.online_payment;
        $ctrl.offlinePayment = $ctrl.course.offline_payment;
        $ctrl.paymentInfo = $ctrl.course.payment_info;
    };


    $ctrl.submit = function () {
        $ctrl.loading = true;
        $http
            .post(`/admin/courses/${$ctrl.course.id}/individual-training/update-settings`, {
                open_sale: $ctrl.openSale,
                cost: $ctrl.cost,
                discount_value: $ctrl.discountValue,
                online_payment: $ctrl.onlinePayment,
                offline_payment: $ctrl.offlinePayment,
                payment_info: $ctrl.paymentInfo,
            })
            .then(
                function () {
                    $ctrl.loading = false;
                    Notifier.success('Успешно обновлен', 2);

                    window.location = `/admin/courses/${$ctrl.course.id}/individual-training/settings`;
                },
                function (error) {
                    $ctrl.loading = false;
                    ErrorResponseParser.parse(error);
                }
            )
    };

}
